import { Component } from '@angular/core';
import { LayoutService } from '../../shared/services/layout.service';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { StorageService } from '../../shared/services/storage.service';


@Component({
	selector: 'customer-home',
	templateUrl: 'customer-home.component.html'
})
export class CustomerHomeComponent {

    constructor(
        private _layoutService: LayoutService,
        private _storageService: StorageService,

	){}
	
    ngOnInit(){
        this._layoutService.setCurrentPage('customer-home');
    }
    getName() {
        var personalData = this._storageService.getLocalItem('personalData');
        var personalName;
        try{
            personalName = JSON.parse(personalData).name;
        }catch(e){
            personalName = '';
        }
        return personalName;
    }
    
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/home/components/customer-home.component.ts